import { createTheme } from "@mui/material";

export const createAppTheme = (primaryColor = '#4F46E5') => {
  return createTheme({
    palette: {
      primary: {
        main: primaryColor,
        light: `${primaryColor}15`, // ~8% opacity for light background
        dark: primaryColor, // You could calculate a darker version if needed
        contrastText: '#fff',
      },
      secondary: {
        main: '#10B981', // Emerald
        light: '#F0FDF4',
        dark: '#059669',
      },
      background: {
        default: '#F8FAFC', // Sleek Slate background
        paper: '#FFFFFF',
      },
      text: {
        primary: '#1E293B', // Dark Slate for better readability
        secondary: '#64748B', // Muted Slate
      },
      divider: '#E2E8F0',
      defualt: {
        main: '#94A3B8',
        light: '#F1F5F9',
        dark: '#64748B',
        contrastText: '#fff',
      },
    },
    typography: {
      fontFamily: "'Poppins', sans-serif",
      fontSize: 13,
      h1: { fontWeight: 700 },
      h2: { fontWeight: 700 },
      h3: { fontWeight: 600 },
      h4: { fontWeight: 600 },
      h5: { fontWeight: 600 },
      h6: { fontWeight: 600 },
      button: {
        textTransform: 'none',
        fontWeight: 500,
      },
    },
    shape: {
      borderRadius: 12,
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            borderRadius: 8,
            padding: '8px 16px',
            boxShadow: 'none',
            '&:hover': {
              boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)',
            },
          },
          containedPrimary: {
            background: primaryColor,
          },
        },
      },
      MuiCard: {
        styleOverrides: {
          root: {
            boxShadow: '0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)',
            border: '1px solid #E2E8F0',
          },
        },
      },
      MuiAppBar: {
        styleOverrides: {
          root: {
            backgroundColor: '#FFFFFF',
            color: '#1E293B',
            boxShadow: '0 1px 2px 0 rgb(0 0 0 / 0.05)',
            borderBottom: '1px solid #E2E8F0',
          },
        },
      },
    },
  });
};

// Default theme for initial load or static parts
export const theme = createAppTheme();